import { sendByEmail } from "@/services/email.queries";
import { sendByText } from "@/services/text.queries";
import { useToastNotify } from "@/stores/toastStore";
import { formatPhoneNumber } from "@/utils/formatPhoneNumber";
import * as Sentry from "@sentry/react-native";
import { useMutation } from "@tanstack/react-query";
import { t } from "@transifex/native";
import { Platform } from "react-native";

export function useSendReceipt() {
  const { notify } = useToastNotify();

  const { mutate: sendReceiptByEmail, isPending: sendReceiptByEmailIsPending } = useMutation({
    mutationKey: ["sendByEmail"],
    mutationFn: sendByEmail,
    onError: (error, variables) => {
      if (!variables.email.includes("@")) {
        notify({
          message: t("No email detected on contact information."),
          severity: "error",
        });
      } else if (!variables.receiptID) {
        notify({
          severity: "error",
          message: t("No receipt detected."),
        });
      } else {
        notify({
          severity: "error",
          message: t("An error occurred when sending the receipt"),
        });
      }

      console.error(`Error sending the receipt: ${error}`);
      Sentry.captureException(error, {
        extra: {
          data: variables,
          localStorage: Platform.OS === "web" ? window.localStorage : null,
        },
      });
    },
    onSuccess: (_, variables) => {
      notify({
        severity: "success",
        message: t("Receipt sent to: {mail}", { mail: variables.email }),
      });
    },
  });

  const { mutate: sendReceiptByPhoneNumber, isPending: sendReceiptByPhoneNumberIsPending } = useMutation({
    mutationKey: ["sendByText"],
    mutationFn: sendByText,
    onError: (error, variables) => {
      notify({
        severity: "error",
        message: t("An error occurred when sending the receipt"),
      });
      console.error(`Error sending the receipt: ${error}`);
      Sentry.captureException(error, {
        extra: {
          data: variables,
          localStorage: Platform.OS === "web" ? window.localStorage : null,
        },
      });
    },
    onSuccess: (_, variables) => {
      notify({
        severity: "success",
        message: t("Receipt sent to: {number}", { number: formatPhoneNumber(variables.phone) }),
      });
    },
  });

  return {
    sendReceiptByEmail,
    sendReceiptByPhoneNumber,
    sendReceiptByPhoneNumberIsPending,
    sendReceiptByEmailIsPending,
  };
}
